module.exports = __webpack_public_path__ + "img/barrage_prize_12.778aecb1.png";